import Model from './Model'

export default class LiveWorkoutCategory extends Model {
  resource() {
    return 'settings/live-workout-categories'
  }
}
